"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import React from "react";
import FactorInvoicesService from "../factor_invoices_service";
import LoadsService from "../loads_service";
import CarrierInvoicesStore from "../../stores/carrier_invoices_store";
class LoadIdAndStatus extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {});
    __publicField(this, "getLoad", () => {
      const carrierInvoiceId = this.props.group.documents[0].carrier_invoice_id;
      const factorInvoiceId = this.props.group.documents[0].factor_invoice_id;
      if (carrierInvoiceId) {
        this.getLoadFromInvoice(carrierInvoiceId);
      } else if (factorInvoiceId) {
        this.getLoadFromFactorInvoice(factorInvoiceId);
      }
    });
    __publicField(this, "getLoadFromFactorInvoice", (factorInvoiceId) => {
      let message = "";
      FactorInvoicesService.getWithId(factorInvoiceId).then((invoice) => {
        if (invoice.state === "processed") {
          message = "Processed";
        } else if (invoice.state === "auto_processed") {
          message = "Auto Processed";
        } else if (invoice.state === "approved") {
          message = "Approved";
        } else if (invoice.state === "exception") {
          message = "Incomplete";
        } else if (invoice.state === "abandoned") {
          message = "Ignored";
        } else if (invoice.state === "purchased") {
          message = "Purchased";
        }
        this.setState({ label: "", state: invoice.state, message });
      });
    });
    __publicField(this, "getLoadFromInvoice", (carrierInvoiceId) => {
      let invoice = CarrierInvoicesStore.find(carrierInvoiceId);
      const loadState = LoadsService.getLoadsByInvoiceIds([carrierInvoiceId])[0];
      if (loadState) {
        this.setState({
          message: loadState.load.load_id,
          state: invoice.state,
          label: "Load ID"
        });
      } else {
        const loadStateIds = this.props.group.documents[0].data.load_state_ids;
        if (loadStateIds) {
          LoadsService.getLoad(loadStateIds[0]).then((ls) => {
            invoice = CarrierInvoicesStore.find(carrierInvoiceId);
            this.setState({
              message: ls.load.load_id,
              state: invoice.state,
              label: "Load ID"
            });
          });
        }
      }
    });
  }
  render() {
    if (this.state.message) {
      const classes = "document-browser__collapsed-list-load_ids document-browser__collapsed-list-load_ids-" + this.state.state;
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          "data-component": "LoadIdAndStatus",
          className: "document-browser__collapsed-list-load_ids-wrapper"
        },
        /* @__PURE__ */ React.createElement("div", { className: "document-browser__collapsed-list-load_ids-label" }, this.state.label),
        /* @__PURE__ */ React.createElement("div", { className: classes }, this.state.message)
      );
    }
    return /* @__PURE__ */ React.createElement("div", null);
  }
  componentDidMount() {
    this.getLoad();
  }
}
export default LoadIdAndStatus;
